const profile = {
  title: "Ma Page d'Accueil",
  premiumBtn: "Devenir membre",
  orderInfoTitle: "Informations sur les autorisations du compte",
  tableProduct: "Produits",
  tableStatus: "Statut",
  tablePermissionDate: "Date de l'autorisation",
  tableValidPeriod: "Date d'expiration",
  validStauts: "En vigueur",
  expiredStauts: "Expiré",
  noData: "Pas de données",
};

export default profile;
